// TODO: move this to json as data
const data = [
  {
    meta: {
      year: 'Current/ Future',
      group: true,
      future: true
    },
    items: [
      {
        text: 'Docker Kubernetes'
      },
      {
        text: 'DevOps Basics'
      },
      {
        text: 'System Design Overview'
      },
      {
        text: 'Competitive Programming Prep'
      },
      {
        text: 'Linux Shell Programming'
      },
      {
        text: 'Python 3'
      }
    ]
  },
  {
    meta: {
      year: '2020',
      group: true
    },
    items: [
      {
        text: 'TypeScript'
      },
      {
        text: 'AWS Basics'
      },
      {
        text: 'Google Cloud Platform Basics'
      },
      {
        text: 'Kotlin'
      }
    ]
  },
  {
    meta: {
      year: '2019',
      group: true
    },
    items: [
      {
        text: 'Jenkins CI/CD'
      },
      {
        text: 'Kotlin'
      },
      {
        text: 'TravisCI'
      },
      {
        text: 'CircleCI'
      }
    ]
  },
  {
    meta: {
      year: '2018',
      group: true
    },
    items: [
      {
        text: 'Data Structures & Algorithms'
      },
      {
        text: 'Advanced Javascript Concepts/ Functional'
      },
      {
        text: 'Google Firebase Hosting/ RelatimeDB'
      },
      {
        text: 'Heroku'
      },
      {
        text: 'React Native'
      },
      {
        text: 'IndexedDB'
      },
      {
        text: 'Service Workers'
      }
    ]
  },
  {
    meta: {
      year: '2017',
      group: true
    },
    items: [
      {
        text: 'Material UI'
      },
      {
        text: 'VueJS-VueX'
      },
      {
        text: 'VS Code Extensions'
      },
      {
        text: 'Google Chrome Extensions'
      },
      {
        text: 'Expo'
      },
      {
        text: 'D3JS'
      },
      {
        text: 'Google Charts'
      },
      {
        text: 'SVG'
      }
    ]
  },
  {
    meta: {
      year: '2016',
      group: true
    },
    items: [
      {
        text: 'React-Redux'
      },
      {
        text: 'ES6'
      },
      {
        text: 'NodeJS'
      },
      {
        text: 'Promises'
      },
      {
        text: 'Webpack-Babel'
      },
      {
        text: 'Jest'
      },
      {
        text: 'Enzyme'
      }
    ]
  },
  {
    meta: {
      year: '2015',
      group: true
    },
    items: [
      {
        text: 'DurandalJS'
      },
      {
        text: 'KnockoutJS'
      },
      {
        text: 'Gulp'
      },
      {
        text: 'Webpack'
      },
      {
        text: 'SCSS'
      }
    ]
  },
  {
    meta: {
      year: '2014',
      group: true
    },
    items: [
      {
        text: 'BackboneJS'
      },
      {
        text: 'AngularJS'
      },
      {
        text: 'Bootstrap 3'
      },
      {
        text: 'Python 2'
      },
      {
        text: 'MySQL'
      }
    ]
  },
  {
    meta: {
      year: '2013',
      group: true
    },
    items: [
      {
        text: 'Balsamiq'
      },
      {
        text: 'Photoshop'
      }
    ]
  },
  {
    meta: {
      year: '2012',
      group: true
    },
    items: [
      {
        text: 'Basic JavaScript'
      },
      {
        text: 'HTML/5'
      },
      {
        text: 'CSS/3'
      },
      {
        text: 'jQuery'
      }
    ]
  },
  {
    meta: {
      year: '2010',
      group: true
    },
    items: [
      {
        text: 'Misc'
      },
      {
        text: 'Bash Scripting for Schedulers'
      },
      {
        text: 'Silverlight'
      },
      {
        text: '.NET Projects'
      }
    ]
  }
];

export default data;
